import clsx from 'clsx';
import { Navbar } from '../../Navbar';
import { twMerge } from 'tailwind-merge';
import { useAppContext } from '@/context/AppContext';
import React, { PropsWithChildren, forwardRef } from 'react';
import { PageHeader } from './PageHeader';
import { useSearchParams } from 'react-router-dom';

interface IProps extends React.ComponentProps<typeof PageHeader> {
  bg?: string;
  /**
   * to remove the navigation bar from DOM
   */
  hideNavbar?: boolean;
  /**
   * to remove the page header (back button + title) from DOM
   */
  hidePageHeader?: boolean;
  className?: string;
  navbarClassName?: string;
  pageHeaderClassName?: string;
  /**
   * to make the navbar sticky
   */
  sticky?: boolean;
}

const Header = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>(
  (
    {
      bg,
      hideNavbar,
      className,
      children,
      sticky,
      hidePageHeader,
      navbarClassName,
      pageHeaderClassName,
      ...rest
    },
    ref
  ) => {
    const { isWebView } = useAppContext();
    const [searchParams] = useSearchParams();
    const hideNavbarParam = searchParams.get('hn') === 'true';

    if (isWebView && hidePageHeader) {
      return null;
    }

    return (
      <header
        id="claims-header"
        ref={ref}
        className={twMerge(
          clsx({
            'flex flex-col gap-y-3 lg:gap-y-16 bg-no-repeat bg-cover z-40':
              true,
            [`${bg}`]: bg,
            'sticky top-0': sticky,
          }),
          className
        )}
      >
        {hideNavbar || hideNavbarParam || isWebView ? null : (
          <Navbar className={navbarClassName} sticky={sticky} bg={bg} />
        )}
        {hidePageHeader ? null : (
          <PageHeader bg={bg} {...rest} className={pageHeaderClassName}>
            {children}
          </PageHeader>
        )}
      </header>
    );
  }
);

export default Header;
